import { render, staticRenderFns } from "./SceneTableEditModal.vue?vue&type=template&id=2d1751ca&scoped=true"
import script from "./SceneTableEditModal.vue?vue&type=script&lang=js"
export * from "./SceneTableEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1751ca",
  null
  
)

export default component.exports